/*  @flow */
import {
  updateAssignProjectLead,
  updateExtendProject,
  updateEndProject,
} from 'permissions/project';
import type { Action } from 'components/ActionsList/ActionsList';

export const actionsListSingle: Action[] = [
  {
    label: 'general:actions.reassign_project_lead',
    icon: '#icon-users',
    class: '',
    action: 'reassignLead',
    permissions: updateAssignProjectLead,
  },
  {
    label: 'general:actions.extend_project',
    icon: '#icon-extend-project',
    class: '',
    action: 'extendProject',
    permissions: updateExtendProject,
  },
  {
    label: 'general:actions.end_project',
    icon: '#icon-end-rental',
    class: '',
    action: 'endProject',
    permissions: updateEndProject,
  },
];

export const actionsListMultiple: Action[] = [
  {
    label: 'general:actions.extend_project_plural',
    icon: '#icon-extend-project',
    class: '',
    action: 'extendProjectMulti',
    permissions: updateExtendProject,
  },
  {
    label: 'general:actions.end_project_plural',
    icon: '#icon-end-rental',
    class: '',
    action: 'endProjectMulti',
    permissions: updateEndProject,
  },
];
